import { useMemo, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { AddCircleOutline, Search } from '@eqi-investimentos/icons/web';
import { Flex, Text, Input } from '@eqi-investimentos/react';
import { Box, Button } from '@chakra-ui/react';
import { useInvest } from '@/contexts/InvestContext';
import { SVGSkeleton } from '@/components/atoms/Skeleton';
import { Thumb } from '@/components/atoms/Thumb';
import { normalizeString } from '@/utils/format';
import { IfRender, MapRender } from '@/utils/jsx';
import { useGetWalletConnectors } from '../../http/client/useGetWalletConnectors';
export const InstitutionsToConnectList = () => {
  const {
    t
  } = useTranslation('common');
  const {
    closeConnectorsDrawer
  } = useInvest();
  const [search, setSearch] = useState('');
  const {
    data: connectors = [],
    isLoading
  } = useGetWalletConnectors();
  const filteredConnectors = useMemo(() => {
    if (isLoading) return [];
    if (search.length > 0) {
      const normalizedSearch = String(normalizeString(search).toLocaleLowerCase().trim());
      return connectors.filter(({
        name
      }) => {
        const normalizedName = String(normalizeString(name).toLocaleLowerCase());
        return normalizedName.includes(normalizedSearch);
      });
    }
    return connectors;
  }, [connectors, isLoading, search]);
  const openPluggyWidget = (connectorId?: string) => {
    closeConnectorsDrawer();
    const connector = filteredConnectors.find(connector => connector?.id === connectorId);
    window.dispatchEvent(new CustomEvent('loaded-pluggy-widget', {
      detail: {
        connector
      }
    }));
  };
  return <Flex flexDir="column" gap="1.875rem" px="12" minH="100dvh" data-sentry-element="Flex" data-sentry-component="InstitutionsToConnectList" data-sentry-source-file="InstitutionsToConnectList.tsx">
      <Text fontSize="lg" fontWeight="normal" lineHeight="7" color="content.primary" data-sentry-element="Text" data-sentry-source-file="InstitutionsToConnectList.tsx">
        {t('screens.myWallet.drawers.connectorsBrokers.subTitle')}
      </Text>

      <Input type="text" w="full" h="3.125rem" borderRadius={6} px="1rem" bg="background.secondary" borderColor="border.secondary" fontSize="sm" color="content.tertiary" placeholder={t('screens.myWallet.drawers.connectorsBrokers.placeholderSearch')} value={search} onChange={({
      target: {
        value
      }
    }) => setSearch(value)} rightIcon={<Box pos="relative" right="1rem" sx={{
      svg: {
        w: '1.5rem',
        h: '1.5rem'
      }
    }}>
            <Search width={24} height={24}
      // className="-mt-2"
      color="content.brand" />
          </Box>} data-sentry-element="Input" data-sentry-source-file="InstitutionsToConnectList.tsx" />

      <Flex flexDir="column" h="full" data-sentry-element="Flex" data-sentry-source-file="InstitutionsToConnectList.tsx">
        <IfRender condition={isLoading} data-sentry-element="IfRender" data-sentry-source-file="InstitutionsToConnectList.tsx">
          <MapRender items={[...Array(8)]} render={() => <SVGSkeleton key={crypto.randomUUID()} className="w-full h-16 my-2.5" />} data-sentry-element="MapRender" data-sentry-source-file="InstitutionsToConnectList.tsx" />
        </IfRender>
        <IfRender condition={!isLoading} data-sentry-element="IfRender" data-sentry-source-file="InstitutionsToConnectList.tsx">
          <MapRender items={filteredConnectors} render={({
          id,
          thumb,
          name
        }) => <Button key={id} variant="ghost" onClick={() => openPluggyWidget(id)} justifyContent="space-between" alignItems="center" gap="2.5" mb="5" pb="5" px="0.625rem" w="full" h="auto" borderBottom="1px solid var(--color-eqi-gray-lighten-3)">
                <Flex alignItems="center" gap="1.875rem">
                  <Thumb src={thumb} alt={`instituicao ${name}`} width={50} height={50} radius={6} />
                  <Text maxW="10.375rem" maxH="1.6875rem" fontSize="sm" fontWeight="semibold" color="content.secondary" textAlign="left" lineHeight="8" whiteSpace="wrap" textOverflow="ellipsis" overflow="hidden" noOfLines={2}>
                    {name}
                  </Text>
                </Flex>
                <Flex alignItems="center" gap="2.5">
                  <AddCircleOutline width={24} height={24} color="content.brand" />
                  <Text fontSize="xs" fontWeight="normal" color="content.secondary">
                    {t('attributes.connect')}
                  </Text>
                </Flex>
              </Button>} data-sentry-element="MapRender" data-sentry-source-file="InstitutionsToConnectList.tsx" />
        </IfRender>
      </Flex>
    </Flex>;
};